<div class="rfr_input-wrapper">
  <ion-item
      lines="none"
      [style]="style"
      [class]="class"
    >
    <!-- <ion-label position="floating">{{ labelText }}</ion-label> -->
    <ion-input
      readonly
      [value]="selectedDate"
      (click)="openDateTimePicker()"
    >
      <div class="rfr-label-text" slot="label">
        {{ labelText }} <ion-text color="danger" *ngIf="required">*</ion-text>
      </div>
    </ion-input>
  </ion-item>
  <ng-content select="[slot=error-message]"></ng-content>
</div>

<ion-modal [isOpen]="isDatePickerOpen" (didDismiss)="closeDateTimePicker()">
  <ng-template>
    <ion-content>
      <ion-datetime
        presentation="date-time"
        [(ngModel)]="tempSelectedDate"
      ></ion-datetime>
      <ion-footer>
        <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="confirmDate()">OK</ion-button>
            <ion-button (click)="cancelDate()">Cancel</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-footer>
    </ion-content>
  </ng-template>
</ion-modal>
